import { useEffect, useState, useRef } from "react";

export default function useApiFilters(filters) {
  const [options, setOptions] = useState({});
  const [loading, setLoading] = useState(false);
  const [isFirstLoad, setIsFirstLoad] = useState(true);

  const abortRef = useRef(null);
  const initialCacheRef = useRef(null); // ⭐ cache for empty filters

  const isFiltersEmpty = (obj) => {
    return Object.values(obj).every(
      (val) => !val || (Array.isArray(val) && val.length === 0)
    );
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      fetchFilters();
    }, 200);

    return () => clearTimeout(timer);
  }, [filters]);

  const fetchFilters = async () => {
    try {
      // ⭐ If filters empty and we have cache → return instantly
      if (isFiltersEmpty(filters) && initialCacheRef.current) {
        setOptions(initialCacheRef.current);
        setIsFirstLoad(false);
        return;
      }

      setLoading(true);

      if (abortRef.current) {
        abortRef.current.abort();
      }

      const controller = new AbortController();
      abortRef.current = controller;

      const res = await fetch(
        "https://api-sales-insights.haqdarshak.com/filter-options",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(filters),
          signal: controller.signal,
        }
      );

      const data = await res.json();

      setOptions(data);

      // ⭐ Save cache when filters are empty
      if (isFiltersEmpty(filters)) {
        initialCacheRef.current = data;
      }

    } catch (err) {
      if (err.name !== "AbortError") {
        console.error("Filter fetch error:", err);
      }
    } finally {
      setLoading(false);
      setIsFirstLoad(false);
    }
  };

  return { options, loading, isFirstLoad };
}